import React from 'react';
import { paths } from 'frameworks_drivers/routes/index';
import { AssistedAddressSearchProvider } from 'context/AssistedAddressInputContext';
import { AssistedInvoiceAddressSearchProvider } from 'context/AssistedInvoiceAddressInputContext';
import { SummaryPageProvider } from '../context/SummaryPageContext';
import CentralHeatingMandatoryPage from '../../presentation/pages/Flow/CentralHeating/CentralHeatingMandatoryPage';
import { ApartmentCountPage } from '../../presentation/pages/Flow/ApartmentCount/ApartmentCountPage';
import ThermalMeteringPage from '../../presentation/pages/Flow/ThermalMetering/ThermalMeteringPage';
import CentralHeatingPage from '../../presentation/pages/Flow/CentralHeating/CentralHeatingPage';
import HotWaterDeliveryPage from '../../presentation/pages/Flow/HotWaterDelivery/HotWaterDeliveryPage';
import HeatingTypePage from '../../presentation/pages/Flow/HeatingType/HeatingTypePage';
import HeatingSourcesPage from '../../presentation/pages/Flow/HeatingSources/HeatingSourcesPage';
import InputEmailAddressPage from '../../presentation/pages/Flow/InputEmailAddress/InputEmailAddressPage';
import LoadingOfferPage from '../../presentation/pages/Flow/LoadingOffer/LoadingOfferPage';
import OfferPage from '../../presentation/pages/Flow/Offer/OfferPage';
import ContactDetailsPage from '../../presentation/pages/Flow/ContactDetails/ContactDetailsPage';
import InvoiceAddressPage from '../../presentation/pages/Flow/InvoiceAddress/InvoiceAddressPage';
import HouseAddressPage from '../../presentation/pages/Flow/HouseAddress/HouseAddressPage';
import BillingPeriodPage from '../../presentation/pages/Flow/BillingPeriod/BillingPeriodPage';
import SummaryPage from '../../presentation/pages/Flow/Summary/SummaryPage';
import ConfirmEmailPage from '../../presentation/pages/Flow/ConfirmEmail/ConfirmEmailPage';
import ConfirmEMailViaLinkPage from '../../presentation/pages/ConfirmEmailViaLink/ConfirmEMailViaLinkPage';
import EmailConfirmedPage from '../../presentation/pages/EmailConfirmed/EmailConfirmedPage';
import { ConfirmOfferStateProvider } from '../../presentation/pages/ConfirmOffer/ConfirmOfferStateProvider';
import ConfirmOfferPage from '../../presentation/pages/ConfirmOffer/ConfirmOfferPage';
import OfferExpiredPage from '../../presentation/pages/OfferExpired/OfferExpiredPage';
import EndPage from '../../presentation/pages/End/EndPage';

export const obFlowRoutes = [
  { path: paths.ApartmentCount, element: <ApartmentCountPage /> },
  { path: paths.ThermalMetering, element: <ThermalMeteringPage /> },
  {
    path: paths.CentralHeatingMandatory,
    element: <CentralHeatingMandatoryPage />
  },
  { path: paths.CentralHeating, element: <CentralHeatingPage /> },
  { path: paths.HotWaterDelivery, element: <HotWaterDeliveryPage /> },
  { path: paths.HeatingType, element: <HeatingTypePage /> },
  { path: paths.HeatingSources, element: <HeatingSourcesPage /> },
  { path: paths.InputEMailAddress, element: <InputEmailAddressPage /> },
  { path: paths.LoadingOffer, element: <LoadingOfferPage /> },
  { path: paths.Offer, element: <OfferPage /> },
  { path: paths.ContactDetails, element: <ContactDetailsPage /> },
  {
    path: paths.InvoiceAddress,
    element: (
      <AssistedInvoiceAddressSearchProvider key={'invoice'}>
        <InvoiceAddressPage />
      </AssistedInvoiceAddressSearchProvider>
    )
  },
  {
    path: paths.HouseAddress,
    element: (
      <AssistedAddressSearchProvider key={'property'}>
        <HouseAddressPage />
      </AssistedAddressSearchProvider>
    )
  },
  { path: paths.BillingPeriod, element: <BillingPeriodPage /> },
  {
    path: paths.Summary,
    element: (
      <SummaryPageProvider>
        <SummaryPage />
      </SummaryPageProvider>
    )
  },
  { path: paths.ConfirmEmail, element: <ConfirmEmailPage /> },
  { path: paths.ConfirmEmailViaLink, element: <ConfirmEMailViaLinkPage /> },
  { path: paths.EMailConfirmed, element: <EmailConfirmedPage /> },
  {
    path: paths.ConfirmOffer,
    element: (
      <ConfirmOfferStateProvider>
        <ConfirmOfferPage />
      </ConfirmOfferStateProvider>
    )
  },
  {
    path: paths.OfferExpired,
    element: <OfferExpiredPage />
  },
  { path: paths.End, element: <EndPage /> }
];
